<template>
    <div id="tree_div">
        <svg id="tree" viewBox="0 0 100 80">
            <defs>
                <marker id="arrowhead" markerWidth="10" markerHeight="7" fill="white"
                refX="0" refY="3.5" orient="auto">
                    <polygon points="0 0, 10 3.5, 0 7" />
                </marker>
            </defs>
            <circle v-for="x in origins"
                  :key="x.country"
                  class="circ"
                  :id="x.country" cx="45%" cy="50%" 
                  :r="radius(x.date)" 
                  :style="color(x.date)"
                  @mouseover="hover = x.country"
                  @mouseleave="hover = false"></circle>
            <line id="axis" x1="45%" y1="50%" x2="90%" y2="50%" stroke="white"
            stroke-width=".1" marker-end="url(#arrowhead)" />
            <text id="axis_label" x="45%" y="52%">1950</text>
            <!--<text id="axis_label" x="85%" y="52%">2021</text>-->
        </svg>
    </div>
    <div id="info">
        <p class="info_p">Nature based early education programs have been around for close to 70 years. As the initial programs became more well established, the concept has spread to many countries around the world. On left, you will find a timeline documenting the histories of a handful of countries that have seen development of forest kindergarten-like programs since the 1950s.</p>
        <hr>
        <p class="info_p1">Country</p>
         <span class="info_p2">{{info1}}</span>
        <p class="info_p1">Date</p>
        <span class="info_p2">{{info2}}</span>
        <p class="info_p1">Program Name</p>
        <span class="info_p2">{{info3}}</span>
        <p class="info_p1">{{info4}}</p>
        <!--<details>-->
        <!--  <summary>{{info4.split(".")[0]}}</summary>-->
        <!--  <p>{{info4}}</p>-->
        <!--</details>-->
    </div>
</template>

<script>
import origins from '../assets/origins.json'
import { scaleLinear } from 'd3-scale';

export default {
  name: 'origins',
  data() {
    return {
      origins: origins.sort((a, b) => (a.date < b.date) ? 1 : -1),
      hover: false
    }
  },
  computed: {
      info1: function() {
          if (this.hover){
            return origins.find(o => o.country === this.hover).country
            } else { return "Currently estimated to be in more than 30 countries"}
      },
      info2: function() {
          if (this.hover){
            return origins.find(o => o.country === this.hover).date
            } else { return "2021"}
      },
      info3: function() {
          if (this.hover){
            return origins.find(o => o.country === this.hover).name
            } else { return "Varies from country to country"}
      },
      info4: function() {
          if (this.hover){
            return origins.find(o => o.country === this.hover).info
            } else { return ""}
      }
    
  },
  methods: {
     radius: function(value) {
        const scale = scaleLinear()
          .domain([1950, 2021])
          .range([0, 40]);
    
        return scale(value)
    },
    color: function(value) {
        const scale = scaleLinear()
          .domain([1950, 2021])
          .range(["#2B1608", "#d2a56d"]);
    
        return "fill:"+scale(value)
    }
  },
  components: {
  },
  setup() {
  }
}
</script>

<style>
details > summary {
  padding: 4px;
  cursor: pointer;
    color: 	white;
    font-family: Josefin;
    font-size: 1.8vw;
}

details > p {
  padding: 4px;
  margin: 0;
    color: 	white;
    font-family: Josefin;
    font-size: 1.2vw;
}

#tree_div {
    min-height: 100%;
    width: 60%;
    float: left;
}

#tree {
    width: 100%;
    height: auto;
    margin-top:5%;
    margin-bottom:4%;
}

#info {
    width: 38%;
    float: left;
    margin-top: 7%;
    background-color: #839788;
    opacity: .85;
    padding: 1% 1% 1% 1%;
}

#axis_label {
    fill: 	white;
    font-family: Josefin;
    font-size: 2px;
}

 .info_p, .info_p1, .info_p2 {
    color: 	white;
    font-family: Josefin;
    padding: 0 1% 0 1%;
}

.info_p {
    font-size: 1.3vw;
}

.info_p1 {
    font-size: 1.2vw;
}

.info_p2 {
    font-size: 1.8vw;
}

.circ {
    stroke: rgb(53, 34, 8); 
    stroke-width: 0.1; 
    /*fill: rgb(128, 100, 67); */
    fill-opacity: 0.4;
    stroke-opacity: 0.5;
}

.circ:hover {
    stroke-opacity: 1;
    stroke-width: .2;
    fill-opacity: 1;
    /*fill: #42694c;*/
}
</style>
